import { Component, inject, input } from '@angular/core';

import { defer } from 'rxjs';

import { CamTenantUrlDisplayerComponent } from '../../../../common/components/tenant-url-displayer/tenant-url-displayer.component';
import { CamInvoicesService } from '../../services/invoices.service';

@Component({
  imports: [CamTenantUrlDisplayerComponent],
  selector: 'cam-invoice-tenant-url-displayer',
  templateUrl: './invoice-tenant-url-displayer.component.html',
})
export class CamInvoiceTenantUrlDisplayerComponent {
  private _invoiceService = inject(CamInvoicesService);

  invoiceId = input.required<string>();

  display = input<'button' | 'icon'>('icon');

  route$ = this._invoiceService.tenantRoute.get$();

  fetch$ = defer(() => this._invoiceService.fetchTenantRoute$(this.invoiceId()));
}
